import { render, staticRenderFns } from "./UserLogin.vue?vue&type=template&id=4c5d7a25&scoped=true"
import script from "./UserLogin.vue?vue&type=script&lang=js"
export * from "./UserLogin.vue?vue&type=script&lang=js"
import style0 from "./UserLogin.vue?vue&type=style&index=0&id=4c5d7a25&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5d7a25",
  null
  
)

export default component.exports